import {loadStorage} from '../../../components/Common/localStorage';
import normalizeContacts from './normalizeContacts';
import {rootEntityId, rootLevelId, gaLinkStatusId} from '../../../util/uiconstants';

export default (payload, response) => {
	let selectedEntitiesId = undefined;
	if (payload.loadFromSession) {
		selectedEntitiesId = loadStorage(payload.projectSessionKey);
	}

	return response.map((e) => {
		const activeEngagementStatuses = ['Active', 'Restored', 'Marked for deletion'];
		const hasAccessGroups = !_.isEmpty(e.accessGroups);
		const isRootEntity = e.id === rootEntityId && e.entityLevel === rootLevelId;
		const hasAccess = e.isAccessible || hasAccessGroups;
		const hasAccessOrRootEntity = hasAccess || isRootEntity;
		const isActiveEngagement = !isRootEntity && activeEngagementStatuses.some((s) => s === e.engagementStatus);
		const isComponentUnlinked = e?.gaLinkStatusId === gaLinkStatusId.unlinked;

		let isChecked = false;
		let enabled = false;

		if (payload.isGroupRiskAssessment && !payload.isContactsPage) {
			isChecked =
				isRootEntity || (hasAccess && isActiveEngagement)
					? selectedEntitiesId
						? selectedEntitiesId.entitiesId.includes(e.id)
						: hasAccessOrRootEntity
					: false;
			enabled = !isComponentUnlinked && (isRootEntity || (hasAccess && isActiveEngagement));
		} else {
			isChecked = hasAccessOrRootEntity
				? selectedEntitiesId
					? selectedEntitiesId.entitiesId.includes(e.id)
					: hasAccessOrRootEntity
				: false;
			enabled = hasAccessOrRootEntity;
		}

		return {
			entityAdmins: e?.entityAdmins,
			accessGroups: e.accessGroups,
			checked: isChecked,
			engagements: e.engagements,
			entityLevel: e.entityLevel,
			entityId: e.entityId,
			id: e.id,
			isEnabled: enabled,
			label: e.entityName,
			parentId: e.parentEntityId,
			bulkChange: true, //Default will be true.
			contacts: normalizeContacts(
				e.contacts,
				payload,
				hasAccess,
				e.entityAdmins,
				isRootEntity,
				payload.isGroupRiskAssessment
			)
		};
	});
};
